import { motion } from "framer-motion";
import { Stethoscope, Sparkles, ClipboardList, Infinity as InfinityIcon } from "lucide-react";
import { WHY_US, IMAGES } from "../../lib/medskin-data";

const ICONS = [Stethoscope, Sparkles, ClipboardList, InfinityIcon];

export const WhyUs = () => {
  return (
    <section id="hvorfor" className="py-24 md:py-36 bg-[#F7F6F3]" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#C4A981]"></span>
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#635D56]">Hvorfor velge oss</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.08] text-[#2C2C2A] tracking-tight font-light" data-testid="why-us-headline">
              Et nivå av <em className="italic text-[#4A4238]">faglighet</em> som setter standarden.
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#635D56] font-light leading-relaxed">
              Hos Medskinby møter du erfarne hudterapeuter med medisinsk forankring – og en arbeidsmetode som forener vitenskap med omsorg.
            </p>
            <div className="mt-10 aspect-[5/4] rounded-[2rem] overflow-hidden">
              <img
                src={IMAGES.products}
                alt="Premium hudpleieprodukter"
                className="w-full h-full object-cover"
                data-testid="why-us-image"
              />
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {WHY_US.map((w, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={w.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className={`p-8 md:p-10 rounded-3xl border border-[#E5E0DA] ${
                    i % 3 === 0 ? "bg-[#4A4238] text-[#F7F6F3]" : "bg-white"
                  } transition-all duration-500 hover:shadow-[0_20px_50px_-25px_rgba(74,66,56,0.25)]`}
                  data-testid={`why-us-card-${i}`}
                >
                  <Icon
                    size={28}
                    strokeWidth={1}
                    className={i % 3 === 0 ? "text-[#C4A981]" : "text-[#4A4238]"}
                  />
                  <h3
                    className={`mt-8 font-serif text-2xl leading-tight ${
                      i % 3 === 0 ? "text-[#F7F6F3]" : "text-[#2C2C2A]"
                    }`}
                  >
                    {w.title}
                  </h3>
                  <p
                    className={`mt-4 text-sm md:text-[0.95rem] font-light leading-relaxed ${
                      i % 3 === 0 ? "text-[#D9D0C5]" : "text-[#635D56]"
                    }`}
                  >
                    {w.description}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
